import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ManagerListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.systemSetting.employee.list("manager"));
  };

  return (
    <MainMenuItem
      itemTitleString="管理者を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ManagerListMenuItem;
